import React from 'react';
import Item from './Item';
import Container from '~/components/Container';
import IconItemEditingTools from '~/components/svg/icon-item-editing-tools.svg';
import IconItemGenerationTools from '~/components/svg/icon-item-generation-tools.svg';
import IconItemOtherTools from '~/components/svg/icon-item-other-tools.svg';
import Config from '~/config';

class Content extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t, lng, option } = this.props;
    const dataOption0 = [
      {
        id: 1,
        src: `${Config.staticPrefix}/static/images/ai-landing-page/photo_editing_acbeauty.png`,
        iconHeader: <IconItemEditingTools />,
        reverse: false,
        title: t('ai_landing_page_option_01_title_01'),
        content: t('ai_landing_page_option_01_content_01'),
        href: `https://ac-beautify.com?gt=1#googtrans(${lng})`,
        positionHref: false,
      },
      {
        id: 2,
        src: `${Config.staticPrefix}/static/images/ai-landing-page/photo_editing_acremove.png`,
        iconHeader: <IconItemEditingTools />,
        reverse: true,
        title: t('ai_landing_page_option_01_title_02'),
        content: t('ai_landing_page_option_01_content_02'),
        href: `https://remove-ac.com/?gt=1#googtrans(${lng})`,
        positionHref: false,
      },
      {
        id: 3,
        src: `${Config.staticPrefix}/static/images/ai-landing-page/photo_editing_accopystamp.png`,
        iconHeader: <IconItemEditingTools />,
        reverse: false,
        title: t('ai_landing_page_option_01_title_03'),
        content: t('ai_landing_page_option_01_content_03'),
        href: `https://copystamp-ac.com/?gt=1#googtrans(${lng})`,
        positionHref: false,
      },
      {
        id: 4,
        src: `${Config.staticPrefix}/static/images/ai-landing-page/photo_editing_acsora.png`,
        iconHeader: <IconItemEditingTools />,
        reverse: true,
        title: t('ai_landing_page_option_01_title_04'),
        content: t('ai_landing_page_option_01_content_04'),
        href: `https://sora-ac.com/?gt=1#googtrans(${lng})`,
        positionHref: false,
      },
      {
        id: 5,
        src: `${Config.staticPrefix}/static/images/ai-landing-page/photo_editing_acclipping.png`,
        iconHeader: <IconItemEditingTools />,
        reverse: false,
        title: t('ai_landing_page_option_01_title_05'),
        content: t('ai_landing_page_option_01_content_05'),
        href: `https://clipping-ac.com/?gt=1#googtrans(${lng})`,
        positionHref: false,
      },
    ];
    const dataOption1 = [
      {
        id: 1,
        src: `${Config.staticPrefix}/static/images/ai-landing-page/image_generation_acartist.png`,
        iconHeader: <IconItemGenerationTools />,
        reverse: false,
        title: t('ai_landing_page_option_02_title_01'),
        content: t('ai_landing_page_option_02_content_01'),
        href: `https://ac-artist.com?gt=1#googtrans(${lng})`,
        positionHref: false,
      },
      {
        id: 2,
        src: `${Config.staticPrefix}/static/images/ai-landing-page/image_generation_acfusion.png`,
        iconHeader: <IconItemGenerationTools />,
        reverse: true,
        title: t('ai_landing_page_option_02_title_02'),
        content: t('ai_landing_page_option_02_content_02'),
        href: `https://fusion-ac.net/?gt=1#googtrans(${lng})`,
        positionHref: false,
      },
      {
        id: 3,
        src: `${Config.staticPrefix}/static/images/ai-landing-page/image_generation_ackao.png`,
        iconHeader: <IconItemGenerationTools />,
        reverse: false,
        title: t('ai_landing_page_option_02_title_03'),
        content: t('ai_landing_page_option_02_content_03'),
        href: `https://kaoac.com/?gt=1#googtrans(${lng})`,
        positionHref: false,
      },
      {
        id: 4,
        src: `${Config.staticPrefix}/static/images/ai-landing-page/image_generation_acgenface.png`,
        iconHeader: <IconItemGenerationTools />,
        reverse: true,
        title: t('ai_landing_page_option_02_title_04'),
        content: t('ai_landing_page_option_02_content_04'),
        href: `${Config.getSiteURL()}/genface`,
        positionHref: false,
      },
      {
        id: 5,
        src: `${Config.staticPrefix}/static/images/ai-landing-page/image_generation_acbaby.png`,
        iconHeader: <IconItemGenerationTools />,
        reverse: false,
        title: t('ai_landing_page_option_02_title_05'),
        content: t('ai_landing_page_option_02_content_05'),
        href: `https://baby-ac.com/?gt=1#googtrans(${lng})`,
        positionHref: false,
      },
    ];
    const dataOption2 = [
      {
        id: 1,
        src: `${Config.staticPrefix}/static/images/ai-landing-page/other_tools_ackukadai.png`,
        iconHeader: <IconItemOtherTools />,
        reverse: false,
        title: t('ai_landing_page_option_03_title_01'),
        content: t('ai_landing_page_option_02_content_05'),
        href: `https://kakudai-ac.com/?gt=1#googtrans(${lng})`,
        positionHref: false,
      },
      {
        id: 2,
        src: `${Config.staticPrefix}/static/images/ai-landing-page/other_tools_accompressor.png`,
        iconHeader: <IconItemOtherTools />,
        reverse: true,
        title: t('ai_landing_page_option_03_title_02'),
        content: t('ai_landing_page_option_03_content_02'),
        href: `https://compressor-ac.net?gt=1#googtrans(${lng})`,
        positionHref: false,
      },
      {
        id: 3,
        src: `${Config.staticPrefix}/static/images/ai-landing-page/other_tools_acscoring.png`,
        iconHeader: <IconItemOtherTools />,
        reverse: false,
        title: t('ai_landing_page_option_03_title_03'),
        content: t('ai_landing_page_option_03_content_03'),
        href: `https://scoring-ac.com?gt=1#googtrans(${lng})`,
        positionHref: false,
      },
      {
        id: 4,
        src: `${Config.staticPrefix}/static/images/ai-landing-page/other_tools_actesou.png`,
        iconHeader: <IconItemOtherTools />,
        reverse: true,
        title: t('ai_landing_page_option_03_title_04'),
        content: t('ai_landing_page_option_03_content_04'),
        href: `https://tesou-ac.com?gt=1#googtrans(${lng})`,
        positionHref: false,
      },
    ];
    let optionData = dataOption0;
    switch (option) {
      case 1:
        optionData = dataOption1;
        break;
      case 2:
        optionData = dataOption2;
        break;
      default:
        optionData = dataOption0;
    }
    return (
      <Container>
        <div className="content-container">
          <div className="item-container-content">
            {optionData.map((item, idx) => {
              return (
                <Item
                  key={idx}
                  src={item.src}
                  iconHeader={item.iconHeader}
                  reverse={item.reverse}
                  title={item.title}
                  content={item.content}
                  href={item.href}
                  positionHref={item.positionHref}
                />
              );
            })}
          </div>
          <style jsx>{`
            .content-container {
              margin-top: 64px;
            }
            .item-container-content {
            }
          `}</style>
        </div>
      </Container>
    );
  }
}

export default Content;
